import React, { useMemo } from "react";
import { Company } from "../../../Models/Company";
import { useTypes } from "../../../utilities/types";
import { getBadge } from "../../Badges/utilities";
import { Carrier } from "../../../Models/Carrier";
import { CarrierConfiguration } from "../../../Models/CarrierConfiguration";

// Funzione che restituisce un componente React (FC)
export const getCompanyOptionStyle = (option: Company): React.FC => {
  const CompanyOption: React.FC = () => {
    const { companies } = useTypes();
    const companyType = companies.find((c) => c.value === option.type);
    return (
      <>
        <img
          src={option.logoDarkUrl}
          className="me-2"
          style={{ maxHeight: "25px", maxWidth: "50px" }}
          alt={option.name}
        />
        <label className="d-inline-block me-2">{option.name}</label>
        {option.externalReference && (
          <span className="me-2" style={{ fontSize: "10px" }}>
            ({option.externalReference})
          </span>
        )}
        {getBadge({ bgColor: companyType?.color, text: companyType?.label })}
      </>
    );
  };

  return CompanyOption;
};

export const CompanyOption: React.FC<{ option: Company }> = React.memo(
  ({ option }) => {
    const { companies } = useTypes();

    const companyType = useMemo(() => {
      return companies.find((c) => c.value === option.type);
    }, [companies, option.type]);

    return (
      <>
        <img
          src={option.logoDarkUrl}
          className="me-2"
          style={{ maxHeight: "25px", maxWidth: "50px" }}
          alt={option.name}
        />
        <label className="d-inline-block me-2">{option.name}</label>
        {option.externalReference && (
          <span className="me-2" style={{ fontSize: "10px" }}>
            ({option.externalReference})
          </span>
        )}
        {getBadge({ bgColor: companyType?.color, text: companyType?.label })}
      </>
    );
  }
);

export const getCarrierOptionStyle = (option: Carrier): React.FC => {
  const CarrierOption: React.FC = () => {
    return (
      <>
        <img
          src={option.logoUrl}
          className="me-2"
          style={{ maxHeight: "25px", maxWidth: "50px" }}
          alt={option.name}
        />
        <label className="d-inline-block me-2">{option.name}</label>
      </>
    );
  };

  return CarrierOption;
};

export const CarrierOption: React.FC<{ option: Carrier }> = React.memo(
  ({ option }) => {
    return (
      <>
        <img
          src={option.logoUrl}
          className="me-2"
          style={{ maxHeight: "25px", maxWidth: "50px" }}
          alt={option.name}
        />
        <label className="d-inline-block me-2">{option.name}</label>
      </>
    );
  }
);

export const getCarrierConfigurationOptionStyle = (
  option: CarrierConfiguration
): React.FC => {
  const CarrierConfigurationsOption: React.FC = () => {
    return (
      <>
        <img
          src={option.carrierLogo}
          className="me-2"
          style={{ maxHeight: "25px", maxWidth: "50px" }}
          alt={option.name}
        />
        <label className="d-inline-block me-2">{option.carrierName}</label>
      </>
    );
  };

  return CarrierConfigurationsOption;
};

export const CarrierConfigurationOption: React.FC<{
  option: CarrierConfiguration;
}> = React.memo(({ option }) => {
  return (
    <>
      <img
        src={option.carrierLogo}
        className="me-2"
        style={{ maxHeight: "25px", maxWidth: "50px" }}
        alt={option.name}
      />
      <label className="d-inline-block me-2">{option.carrierName}</label>
    </>
  );
});
